/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../common';
import { translate } from '../../common/translation/translate';
import { MediaNav } from '../common/subnavigation/mediaNav';
import { PageSubNavLink } from '../common/subnavigation/pageSubNavLink';
import { NewsVideosPageIds, NewsVideosPageRoutePaths } from './newsVideoPageNavTypes';

interface NewsVideosPageSubNavigationProps {
    activePageId: string;
    enableNewsLandingPageOnWeb2: boolean;
    enableVideoLandingPageOnWeb2: boolean;
}

const mapStoreStateToProps = (storeState: any) => {
    const { pageId, enableNewsLandingPageOnWeb2, enableVideoLandingPageOnWeb2 } = storeState?.appState?.appState || {};

    return {
        activePageId: pageId,
        enableNewsLandingPageOnWeb2,
        enableVideoLandingPageOnWeb2
    };
};

const mapDispatchToProps = {};

export const NewsVideosPageSubNavigation = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo((
    {
        activePageId,
        enableNewsLandingPageOnWeb2,
        enableVideoLandingPageOnWeb2
    }: NewsVideosPageSubNavigationProps) => {
    return (
        <MediaNav>
            <Container>
                <PageSubNavLink
                    isActive={activePageId === NewsVideosPageIds.news}
                    linkName={translate('news')}
                    linkUrl={NewsVideosPageRoutePaths.news}
                    linkToWeb2={enableNewsLandingPageOnWeb2}
                />
                <PageSubNavLink
                    isActive={activePageId === NewsVideosPageIds.videos}
                    linkName={translate('videos')}
                    linkUrl={NewsVideosPageRoutePaths.videos}
                    linkToWeb2={enableVideoLandingPageOnWeb2}
                />
            </Container>
        </MediaNav>
    );
}));

NewsVideosPageSubNavigation.displayName = 'NewsVideosPageSubNavigation';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;
